module.exports = __webpack_public_path__ + "img/female-adult-foot.105e9196.svg";